import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import initialImg from '../../../../images/icons/upload_new.svg';
import CommonDatePicker, {
  currentYear
} from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import PopUp from '../../../../common/components/PopUp/PopUp';
import get from 'lodash/get';
import _ from 'lodash';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import { Formik, Form } from 'formik';
import {
  UserKycUpload,
  UploadFileToS3,
  isDlUploaded,
  UserKycVarifyDetails,
  getApiDl
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import classes from './DlComp.module.css';

const validationSchema = Yup.object().shape({
  file: Yup.array().when('otherRoute', {
    is: false,
    then: Yup.array()
      .min(2, 'must upload 2 files atleast')
      .required('file is required')
      .of(Yup.string().required())
  }),

  imgUrl: Yup.string().when('otherRoute', {
    is: false, // alternatively: (val) => val == true
    then: Yup.string().required(' required')
  }),
  fullName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  fatherName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!'),
  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  dlNo: Yup.string()
    .min(13, ' should be atleast of 13 digit')
    .max(16, ' should be max of 16 digit')
    .required('Required'),
  addrerss_line1: Yup.string().required('Required'),
  addrerss_line2: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  pincode: Yup.string()
    .required('Required')
    .max(6, 'Pincode should be 6 digit numbers')
    .matches(/\d{6}/, 'Pincode should be digits only')
});

let StateList = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli',
  'Daman and Diu',
  'Delhi',
  'Lakshadweep',
  'Puducherry'
];
var numberFormat = function(number, width) {
  return (
    new Array(+width + 1 - (parseInt(number) + '').length).join('0') +
    parseInt(number)
  );
};

const DlComp = props => {
  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        otherRoute: '',
        fullName: '',
        fatherName: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(parseInt(currentYear) - 18),
          label: String(parseInt(currentYear) - 18)
        },
        dlNo: '',
        addrerss_line1: '',
        addrerss_line2: '',
        city: '',
        state: { value: '', label: 'State' },
        pincode: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setTimeout(() => props.handleSubmit(), 2000);
      }}
    >
      {({
        values: data,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        validateForm,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting,
        resetForm,
        setSubmitting
      }) => {
        const { file, imgUrl } = data;
        const [fileUploaded, setFileUploaded] = useState(false);
        const [loading, setLoading] = useState(false);
        const [showFullImage, setShowFullImage] = useState(false);
        const [LeadDetails, setLeadDetails] = useState('');
        const [show, setShow] = useState(false);
        const [verifying, setVerifying] = useState(false);
        const [case403, setCase403] = useState(false);
        const [frontFaceUploaded, setFrontFaceUploaded] = useState(false);
        const [BackFaceUploaded, setBackFaceUploaded] = useState(false);
        const [frontFaceError, setFrontFaceError] = useState(false);
        const [backFaceError, setBackFaceError] = useState(false);
        const [stateList, setStateList] = useState([]);
        const [verified, setVerified] = useState(false);
        const [verificationFailed, setVerificationFailed] = useState(false);
        const [verificationPending, setVerificationPending] = useState(false);
        const [openFormSection, setOpenFormSection] = useState(true);
        const [s3ImgFront, setS3ImgFront] = useState([]);
        const [s3ImgBack, setS3ImgBack] = useState([]);
        const [userData, setUserData] = useState('');
        const [hasDocuments, setHasDocuments] = useState(null);
        const [Edit1, setEdit1] = useState(false);
        const [Edit2, setEdit2] = useState(false);

        useEffect(() => {
          const myAsync = async () => {
            let data = getApplicantionInfo();
            const { leadId, leadApplicantId } = data;
            await getApiDl(leadId, leadApplicantId)
              .then(data => {
                if (data?.links?.length === 0) setHasDocuments(false);
                else {
                  let { links, userData } = data;
                  links.map(el => {
                    if (el?.tag === 'front') {
                      setS3ImgFront(el?.url);
                      setFieldValue('otherRoute ', true);
                    } else setS3ImgBack(el?.url);
                  });
                  setUserData(userData);
                  setHasDocuments(true);
                }
              })
              .catch(err => console.log(err));
          };
          myAsync();
        }, []);

        //fetching the data from get

        useEffect(() => {
          if (userData) {
            setFieldValue('fullName', userData?.fullName);
            setFieldValue('fatherName', userData?.fathersName);
            setFieldValue('dlNo', userData?.dlNumber);
            setFieldValue('city', userData?.address?.city);
            setFieldValue('state', {
              value: userData?.address?.state,
              label: userData?.address?.state
            });
            setFieldValue('pincode', userData?.address?.pinCode);
            setFieldValue('addrerss_line2', userData?.address?.line2);
            setFieldValue('addrerss_line1', userData?.address?.line1);

            const breakTheDate = userData?.dob?.toString().split('-');
            setFieldValue('year', {
              value: breakTheDate[0],
              label: breakTheDate[0]
            });

            setFieldValue('month', {
              value: breakTheDate[1],
              label: breakTheDate[1]
            });
            setFieldValue('date', {
              value: breakTheDate[2],
              label: breakTheDate[2]
            });
            setTimeout(() => {
              validateForm();
            }, 1000);
          }
        }, [userData]);

        useEffect(() => {
          let StateListArray = [];

          StateList.sort().map(each =>
            StateListArray.push({
              label: each,
              value: each
            })
          );
          setStateList(StateListArray);
        }, []);

        useEffect(() => {
          resetForm();
          setLeadDetails(getApplicantionInfo());
          return () => {};
        }, []);

        //uploading first file
        useEffect(() => {
          validateForm();
          if (file[0] && file[0][0]) {
            setLoading(true);
            setBackFaceUploaded(false);
            UserKycUpload(
              file[0][0],
              LeadDetails.leadId,
              LeadDetails.leadApplicantId,
              'dl',
              'front'
            )
              .then(data => {
                var { url, fileName, requestId } = data;
                localStorage.setItem('doc_id', JSON.stringify(requestId));
                UploadFileToS3(url, file[0][0])
                  .then(res => {
                    isDlUploaded(
                      LeadDetails.leadId,
                      LeadDetails.leadApplicantId,
                      requestId
                    )
                      .then(res => {
                        setLoading(false);
                        setFrontFaceUploaded(true);
                      })
                      .catch(err => {
                        setLoading(false);
                        setFrontFaceError(true);
                      });
                  })
                  .catch(err => {
                    setLoading(false);
                    setFrontFaceError(true);
                  });
              })
              .catch(err => {
                setLoading(false);
                if (err?.response?.status === 403) {
                  setCase403(true);
                } else {
                  setFrontFaceError(true);
                }
              }); //
          }
          return () => {
            setFrontFaceUploaded(false);
            setShow(true);
          };
        }, [file[0]]);

        //uploading second file
        useEffect(() => {
          validateForm();
          if (file[1] && file[1][0]) {
            setLoading(true);
            setFrontFaceUploaded(false);
            UserKycUpload(
              file[1][0],
              LeadDetails.leadId,
              LeadDetails.leadApplicantId,
              'dl',
              'back'
            )
              .then(data => {
                var { url, fileName, requestId } = data;
                localStorage.setItem('doc_id', JSON.stringify(requestId));
                UploadFileToS3(url, file[1][0])
                  .then(res => {
                    isDlUploaded(
                      LeadDetails.leadId,
                      LeadDetails.leadApplicantId,
                      requestId
                    )
                      .then(res => {
                        setLoading(false);
                        setBackFaceUploaded(true);
                      })
                      .catch(err => {
                        setLoading(false);
                        setBackFaceError(true);
                      });
                  })
                  .catch(err => {
                    setLoading(false);
                    setBackFaceError(true);
                  });
              })
              .catch(err => {
                setLoading(false);
                setBackFaceError(true);
                if (err?.response?.status === 403) {
                  setCase403(true);
                } else {
                  setBackFaceError(true);
                }
              });
          }
          return () => {
            setBackFaceUploaded(false);
            setShow(true);
          };
        }, [file[1]]);

        useEffect(() => {
          setFrontFaceUploaded(false);
          setBackFaceUploaded(false);
          setVerificationFailed(false);
          setVerificationPending(false);
          setCase403(false);
          if (verifying) {
            setVerified(false);
            setShow(true);
            setSubmitting(true);
            UserKycVarifyDetails(
              LeadDetails.leadId,
              LeadDetails.leadApplicantId,
              {
                dlNumber: data.dlNo,
                dob:
                  data.year.value +
                  '-' +
                  numberFormat(data.month.value, 2) +
                  '-' +
                  numberFormat(data.date.value, 2),
                fullName: data.fullName,
                fathersName: data.fatherName,
                address: {
                  line1: data.addrerss_line1,
                  line2: data.addrerss_line2,
                  city: data.city,
                  state: data.state.value,
                  pinCode: data.pincode
                }
              },
              'dl'
            )
              .then(data => {
                setVerifying(false);
                if (data) {
                  setVerified(true);
                } else {
                  setVerificationPending(true);
                }
              })
              .catch(err => {
                setVerifying(false);
                if (err) {
                  if (
                    err?.response?.status > 499 &&
                    err?.response?.status < 600
                  ) {
                    setVerificationPending(true);
                    handleSubmit();
                  } else if (err?.status === 403) setCase403(true);
                  else {
                    setVerificationFailed(true);
                    handleSubmit();
                  }
                }
              });
          }
          return () => {
            setShow(true);
            setVerificationPending(false);
            setVerificationFailed(false);
          };
        }, [verifying]);

        useEffect(() => {
          if (verified) setTimeout(() => handleSubmit(), 500);
        }, [verified]);
        useEffect(() => {
          validateForm();
          if (file.length === 2) {
            setShowFullImage(true);
          }
        }, [file[0], file[1]]);

        useEffect(() => {
          if (frontFaceUploaded) {
            setOpenFormSection(false);
            setFileUploaded(true);
          }
        }, [frontFaceUploaded, BackFaceUploaded]);

        const propsRenderer = () => {
          let props = {};
          if (verified) {
            props.type = 'success';
            props.text = 'Dl verified successfully ';
            return props;
          }
          if (verificationPending) {
            props.type = 'loading';
            props.text = 'Dl verification is pending!!';
            return props;
          }
          if (BackFaceUploaded) {
            props.autoClose = true;
            props.type = 'success';
            props.text = 'Dl Back Face Uploaded Successfully. .';
            return props;
          }
          if (frontFaceUploaded) {
            props.autoClose = true;
            props.type = 'success';
            props.text = 'Dl Front Face Uploaded Successfully. .';
            return props;
          }
          if (loading) {
            props.type = 'loading';
            props.text =
              loading && !verifying
                ? 'Uploading . .'
                : ' Verifying Information , pleases wait .';
            return props;
          }
          if (verifying && !verified && !verificationPending) {
            props.type = 'loading';
            props.text = ' Verifying Information , pleases wait. . .';
            return props;
          }
          if (verificationFailed) {
            props.autoClose = true;
            props.type = 'fail';
            props.text =
              'Dl verification failed!! please check the details and try again. .';
            return props;
          }
        };

        return hasDocuments === null ? (
          <div className={'w-full mt-10 mx-auto'}>
            <CircularLoading />
          </div>
        ) : (
          <>
            <PopUp {...propsRenderer()} setShow={setShow} show={show} />

            <form
              onSubmit={handleSubmit}
              className="outer_comp w-full font-roboto px-5 mt-8"
            >
              {hasDocuments && hasDocuments !== null ? (
                <p className="text-black-1002 font-medium text-lg  hidden md:block">
                  Upload Driving License
                </p>
              ) : null}

              <div className="inner_comp  mt-6 md:max-w-4xl mx-auto mb-3">
                <div
                  className={
                    (showFullImage ? 'h-44 ' : 'h-44 ') +
                    (hasDocuments ? ' h-auto pb-4' : '') +
                    (!fileUploaded
                      ? ' bg-white rounded-lg md:rounded-none border border-navy-200 md:border-0 md:shadow-none  '
                      : '  ') +
                    ' mx-auto md:m-0 relative  md:h-auto md:w-full  md:max-w-3xl pt-3 pl-3 md:pl-0 md:pt-0 '
                  }
                >
                  {fileUploaded ? (
                    <p className="mx-auto text-center font-roboto font-medium text-base mb-4 ">
                      Driving License
                    </p>
                  ) : (
                    <p className="block md:hidden w-full">
                      Upload Driving License
                    </p>
                  )}

                  <div
                    className={
                      hasDocuments
                        ? 'flex flex-col mx-auto justify-around pt-4 md:flex md:flex-row md:flex-wrap justify-around'
                        : ' inline-flex md:flex md:flex-row md:flex-wrap justify-around '
                    }
                  >
                    <div
                      className={
                        (hasDocuments ? 'mx-auto' : '') + ' md:mx-2 mt-3 '
                      }
                    >
                      {hasDocuments &&
                      hasDocuments !== null &&
                      !Edit1 &&
                      s3ImgFront ? (
                        <ShowGetImage img={s3ImgFront} setEdit={setEdit1} />
                      ) : (
                        <GlobalUploadComp
                          data={data}
                          imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showFullImage={showFullImage} // boolean , to change mobile upload image view
                          initialImg={initialImg} // initial image
                          subInst="Click here to upload"
                          subtext="CHOOSE FRONT VIEW"
                        />
                      )}
                      <p className="w-9/12 mt-2.5 block md:hidden text-center font-normal text-black-400 text-sm ">
                        Front
                      </p>
                    </div>
                    <div
                      className={
                        (showFullImage ? 'md:m-0 ' : '') +
                        (fileUploaded ? ' md:m-0  ' : '') +
                        (fileUploaded && !hasDocuments ? 'ml-6 ' : '') +
                        (hasDocuments
                          ? ' mx-auto overflow-hidden '
                          : ' md:mx-2 ml-2 ') +
                        ' mt-3 md:mt-3 md:mx-2'
                      }
                    >
                      {hasDocuments &&
                      hasDocuments !== null &&
                      !Edit2 &&
                      s3ImgBack ? (
                        <ShowGetImage img={s3ImgBack} setEdit={setEdit2} />
                      ) : (
                        <GlobalUploadComp
                          data={data}
                          imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showFullImage={showFullImage} // boolean , to change mobile upload image view
                          initialImg={initialImg} // initial image
                          subInst="Click here to upload"
                          subtext="CHOOSE BACK VIEW"
                        />
                      )}
                      <p className="w-9/12 mt-2.5 block md:hidden text-center font-normal text-black-400 text-sm">
                        Back
                      </p>
                    </div>
                  </div>
                </div>
                {(fileUploaded || userData || hasDocuments) && (
                  <div
                    className={
                      classes.form_inputs +
                      ' mx-auto md:w-auto p-2 mt-2 flex flex-col md:flex-row md:flex-wrap  items-center justify-between md:mt-2 md:mx-auto md:max-w-3xl'
                    }
                  >
                    <div className=" md:w-75 w-full  my-4 mx-2 ">
                      <CommonInput
                        name="fullName"
                        id="fullName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.fullName}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Full Name"
                        error={
                          (touched?.fullName || '') && (errors?.fullName || '')
                        }
                        errorMsg={errors?.fullName || ''}
                        touched={touched?.fullName || ''}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2">
                      <CommonInput
                        name="fatherName"
                        id="fatherName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.fatherName}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Father’s Name"
                        error={
                          (touched?.fatherName || '') &&
                          (errors?.fatherName || '')
                        }
                        errorMsg={errors?.fatherName || ''}
                        touched={touched?.fatherName || ''}
                      />
                    </div>
                    <div
                      className={
                        (errors?.fullName || false ? 'mt-6 ' : 'my-4 ') +
                        ' DOB_field md:w-75 w-full  mx-2 '
                      }
                    >
                      <div className=" absolute -mt-6 text-grey-1003">DOB</div>
                      <CommonDatePicker
                        onChangeMonth={(value, isValidDate) => {
                          setFieldValue('month', value, true);
                          setFieldTouched('month', true, false);
                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeYear={(value, isValidDate) => {
                          setFieldValue('year', value, true);
                          setFieldTouched('year', true, false);

                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeDate={value => {
                          setFieldValue('date', value, true);
                          setFieldTouched('date', true, false);
                        }}
                        valueMonth={data.month}
                        valueYear={data.year}
                        valueDate={data.date}
                        errorYear={
                          (touched?.year || '') &&
                          get(errors, 'year.value', false)
                        }
                        touchedYear={touched?.year || ''}
                        onBlurYear={() => {
                          setFieldTouched('year', true, true);
                        }}
                        errorMonth={
                          (touched?.month || '') &&
                          get(errors, 'month.value', false)
                        }
                        touchedMonth={touched?.month || ''}
                        onBlurMonth={() => {
                          setFieldTouched('month', true, true);
                        }}
                        errorDate={
                          (touched?.date || '') &&
                          get(errors, 'date.value', false)
                        }
                        touchedDate={touched?.date || ''}
                        onBlurDate={() => {
                          setFieldTouched('date', true, true);
                        }}
                        type="dob"
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2">
                      <CommonInput
                        name="dlNo"
                        id="dlNo"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.dlNo}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="DL Number"
                        error={(touched?.dlNo || '') && (errors?.dlNo || '')}
                        errorMsg={errors?.dlNo || ''}
                        touched={touched?.dlNo || ''}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2">
                      <CommonInput
                        name="addrerss_line1"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.addrerss_line1}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Address Line 1"
                        error={touched.addrerss_line1 && errors.addrerss_line1}
                        errorMsg={errors.addrerss_line1}
                        touched={touched.addrerss_line1}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2">
                      <CommonInput
                        name="addrerss_line2"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.addrerss_line2}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Address Line 2"
                        error={touched.addrerss_line2 && errors.addrerss_line2}
                        errorMsg={errors.addrerss_line2}
                        touched={touched.addrerss_line2}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2">
                      <CommonInput
                        name="city"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.city}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="City"
                        error={touched.city && errors.city}
                        errorMsg={errors.city}
                        touched={touched.city}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2 -mt-2">
                      <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                        State
                      </div>
                      <CommonSelect sort={true}
                        name="state"
                        value={data.state}
                        onChange={e => {
                          setFieldValue('state', {
                            value: e.value,
                            label: e.value
                          });
                        }}
                        options={stateList}
                        isHoverEffect
                        stylesContainer={{
                          height: '52px',
                          marginBottom: '0px',
                          fontSize: '40px'
                        }}
                        dropdownStyle={{
                          top: '52px',
                          color: 'rgba(0,0,0,0.87)',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          alignItems: 'center',
                          fontFamily: 'Roboto',
                          fontWeight: 400
                        }}
                        styleText={{
                          fontSize: '14px',
                          padding: '0 25px'
                        }}
                        error={
                          touched.state && get(errors, 'state.value', false)
                        }
                        touched={touched.state}
                        onBlur={e => {
                          () => {};
                        }}
                      />
                    </div>
                    <div className="md:w-75 w-full my-4 mx-2 ">
                      <CommonPincode
                        name="pincode"
                        value={data.pincode}
                        onChange={e => {
                          if (e.target.value.length < 6 && !hasDocuments) {
                            // handleChange(e);
                            setFieldValue('city', '');
                            setFieldValue('state', '');
                          }
                          handleChange(e);
                        }}
                        error={errors?.pincode && touched?.pincode}
                        errorMsg={errors?.pincode}
                        touched={touched?.pincode}
                        onPinCodeSucessOrFailure={obj => {
                          const { err, data: pincodeData } = obj;
                          if (!err && pincodeData) {
                            setFieldValue('city', pincodeData.District);
                            setFieldValue('state', {
                              value: pincodeData.State,
                              label: pincodeData.State
                            });
                          } else {
                            setFieldError('pincode', 'Pincode is not valid');
                          }
                        }}
                        onBlur={e => {
                          handleBlur(e);
                        }}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                      />
                    </div>
                  </div>
                )}
                {/* button if want to modify get response */}
                <div className={hasDocuments ? 'block ' : 'hidden'}>
                  <button
                    type="button"
                    onClick={() => {
                      setVerifying(true);
                    }}
                    disabled={!_.isEmpty(errors)}
                    className=" submitButton text-14 w-56 h-12 font-medium  font-roboto"
                  >
                    save and update
                  </button>
                </div>
                {/* button for the lead add haven't added any doc previously */}
                <div className={hasDocuments ? 'hidden' : ''}>
                  <button
                    disabled={
                      openFormSection ? !fileUploaded : !_.isEmpty(errors)
                    }
                    type={'button'}
                    onClick={() => {
                      if (fileUploaded) setVerifying(true);
                    }}
                    className={
                      (!fileUploaded ? 'hidden' : ' ') +
                      ' submitButton  w-56 h-12 font-medium  font-roboto mt-11'
                    }
                  >
                    {fileUploaded ? 'Save & Verify' : 'Next'}
                  </button>
                </div>
              </div>
            </form>
          </>
        );
      }}
    </Formik>
  );
};
export default withErrorHandler(DlComp);
